/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const GLOBAL_CONSTANT = {
  LEGAL_TEXT: 'legal-text',
  MAX_PLANS_BLADE_VISIBLE: 5,
  ENTRUST_LEGAL_PATH: 'https://www.entrust.net/customer/profile.cfm?domain=',
  UNAUTH_REFILL: 'UNAUTHREFILL',
};

export const GPC_CONSTS = {
  NAVIGATOR: 'navigator',
  GPC: 'globalPrivacyControl',
  GPC_VAR: 'gpcDNTSet',
  COOKIE_NAME: 'dnt',
  DO_NOT_SELL: 'DoNotSell',
  SELL: 'Sell',
  YES: 'Yes',
  NO: 'No',
};
